import { ReactNode } from 'react';

import { Box, Stack } from '@mui/material';

import { StlPopup } from 'features/common/StlPopup/StlPopup';

import { InfoAlert } from './Alerts';

interface ConfirmCreatePopupProps {
  isOpen: boolean;
  onApply: () => void;
  onClose: () => void;
  onBack: () => void;
  itemName: string;
  confirmBody?: ReactNode;
  infoAlert?: string;
}

export function ConfirmCreatePopup({
  isOpen,
  onApply,
  itemName,
  confirmBody,
  onClose,
  onBack,
  infoAlert,
}: ConfirmCreatePopupProps) {
  return (
    <StlPopup
      sx={{ width: '480px' }}
      btnTxt="Confirm"
      title={`Confirm ${itemName}`}
      isOpen={isOpen}
      onClose={onClose}
      onApply={onApply}
      showCloseBtn
      closeOnApply
      cancel={false}
      onBack={onBack}
    >
      <Stack display="flex" gap="0.75rem">
        {infoAlert && <InfoAlert large txt={infoAlert} />}
        {confirmBody && <Box>{confirmBody}</Box>}
      </Stack>
    </StlPopup>
  );
}
